export default __webpack_public_path__ + "static/media/flag1.9b167fd2.svg";